module.exports = __webpack_public_path__ + "static/img/map_icon.e72946b6.png";